module.exports = __webpack_public_path__ + "img/filter-welcome-background-toyota.8716e012.png";